export default __webpack_public_path__ + "static/media/ArticlesofIncorporationSigned.725b701d.pdf";